import {useContext} from 'react';
import {createNamedContext} from '~/util';

export const PolicySearchRequestContext = createNamedContext('PolicySearchRequestContext');

export const usePolicySearchRequest = () => useContext(PolicySearchRequestContext);
